import { SortOrder } from "element-ui/types/table";
import { PresetSortConditionItem } from "../../document";
import { WorkflowListSortItemKinds } from "../kinds";

export class ReceptionDetailPresetSortCondition {
  label: string;
  items: ReceptionDetailPresetSortConditionItem[];
  isDefault: boolean;
}

export class ReceptionDetailPresetSortConditionItem implements PresetSortConditionItem {
  sortType?: WorkflowListSortItemKinds;
  orderType: SortOrder;
}
